export default __webpack_public_path__ + "static/media/logo-flat.9d413fe5.svg";